import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const lTheme = localStorage.getItem("theme")
let initialState = {
    theme: lTheme ? lTheme : "dark",
};

export const themeSlice = createAsyncThunk(
    "theme",
    async (data) => {
        return data
    }
)


const themeSliceRducer = createSlice({
    name: "branch",
    initialState,

    extraReducers: (builder) => {
        builder.addCase(themeSlice.pending, (state, action) => {
            state.theme = lTheme;
        });
        builder.addCase(themeSlice.fulfilled, (state, action) => {
            state.theme = action.payload;
        });
        builder.addCase(themeSlice.rejected, (state, action) => {
            state.theme = "dark";
        });
    },
});


export default themeSliceRducer.reducer;
